export default __webpack_public_path__ + "static/media/SVEA_logo_black.9a0af7cd.svg";